import React from "react";
import WassapButton from "../components/WassapButton";
import RequestButton from '../components/RequestButton';
import "../styles/styles.css";

function HomePage() {
  return (
    <div className="home-page">
      <header className="home-header">
        <div className="hero-text">
          <h1>Gestión y Tramitación Digital Avanzada</h1>
          <p>La solución integral para todas sus necesidades de gestión y creación de documentos, diseñada para facilitar trámites y procesos de forma rápida y profesional.</p>
          <a href="#services" className="btn-primary">
            Explorar Servicios
          </a>
        </div>
      </header>
      <section id="about" className="about-section">
        <h2>Sobre nosotros</h2>
        <p>
        Explora todos nuestros servicios y realiza tus solicitudes en línea. Contamos con un equipo listo para ayudarte a resolver tus necesidades documentales, garantizando rapidez y profesionalismo.
¿Tienes preguntas? ¡Contáctanos hoy y descubre cómo podemos facilitar tu día a día! 
<WassapButton/>
        </p>
      </section>

      <section id="services" className="services-section">

        <h2>Nuestros servicios principales</h2>


        <div className="services-container">
          <div className="service-card">
            <h3>Certificados de Tradición y Libertad</h3>
            <p>
            Te ayudamos a obtener de manera rápida y confiable los certificados de tradición y libertad necesarios para tus trámites legales y notariales. Olvídate de las filas y deja todo en manos de expertos.
            </p>
            <RequestButton />
          </div>



          <div className="service-card">
            <h3>Redacción de Documentos y Cartas</h3>
            <p>
            <p>Nuestros expertos en redacción profesional ofrecen soluciones personalizadas para:</p>
    <ul>
        <li>Contratos de compraventa.</li>
        <li>Contratos de alquiler.</li>
        <li>Derechos de petición.</li>
        <li>Cartas de solicitud y hojas de vida.</li>
    </ul>
    <p>Nos adaptamos a tus necesidades, garantizando un lenguaje claro y legalmente válido.</p>
            </p>
            <RequestButton />
          </div>



          <div className="service-card">
            <h3>OCR de Documentos</h3>
            <p>
            Convierte tus documentos físicos o escaneados en archivos digitales 
            completamente editables con nuestro servicio de OCR 
            (Reconocimiento Óptico de Caracteres). Ideal para quienes desean optimizar su tiempo al digitalizar grandes volúmenes de texto.
            </p>
            <RequestButton />
          </div>


          <div className="service-card">
            <h3>Consulta de Resultados ICFES</h3>
            <p>
            ¿Necesitas tus resultados de exámenes antiguos? Te ayudamos a consultar tus resultados ICFES desde 
            1978 hasta la fecha actual de forma rápida y sencilla.
            </p>
            <RequestButton />
          </div>

          <div className="service-card">
            <h3>Organización de Documentos en PDF</h3>
            <p>
            ¿Tienes múltiples archivos PDF desorganizados? Nosotros nos encargamos de organizar y 
            optimizar tus documentos, creando un formato limpio y profesional.
            </p>
            <RequestButton />
          </div>






        </div>
      </section>
    </div>
  );
}

export default HomePage;
